import { styled } from 'styled-components'

export const IconWrap = styled.div<{ $bgColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : 'var(--primary100)')};
  border-radius: 8px;
`

export const HelpIconButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: transparent;
  justify-content: center;
`
